module.exports = __webpack_public_path__ + "static/media/tendericon03.9e5c6107.png";